module.exports = __webpack_public_path__ + "static/media/img_Characterdesign-Junior-01Champion_J07.ac428e70.png";